package com.example.mystybag.login.model

/**
 * Business category enum for merchants.
 * Maps to database IDs from server.
 * 0 is not a valid value and should not be sent.
 */
enum class MerchantBusinessCategory(val id: Long, val stringKey: String) {
    BAKERY(1, "business_category_bakery"),
    CONFECTIONERY(2, "business_category_confectionery"),
    FOOD_FOR_HOME(3, "business_category_food_for_home"),
    FISH_MARKET(4, "business_category_fish_market");

    companion object {
        fun fromId(id: Long): MerchantBusinessCategory? {
            return values().find { it.id == id }
        }

        fun fromIdOrNull(id: Long?): MerchantBusinessCategory? {
            return id?.let { fromId(it) }
        }
    }
}
